import { Icon24BrushLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PainterIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_294_167)">
        <path
          d="M1.5 20.25H8.625C9.58918 20.25 10.5317 19.9641 11.3334 19.4284C12.1351 18.8927 12.7599 18.1314 13.1289 17.2406C13.4979 16.3498 13.5944 15.3696 13.4063 14.4239C13.2182 13.4783 12.7539 12.6096 12.0721 11.9279C11.3904 11.2461 10.5217 10.7818 9.57607 10.5937C8.63041 10.4056 7.65021 10.5021 6.75942 10.8711C5.86863 11.2401 5.10726 11.8649 4.57159 12.6666C4.03591 13.4683 3.75 14.4108 3.75 15.375C3.75 18.75 1.5 20.25 1.5 20.25Z"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5386 10.89C12.3376 8.46469 16.8245 3 21.0001 3C21.0001 7.17563 15.5354 11.6625 13.1101 13.4616"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4688 8.49756C13.7425 9.21067 14.7941 10.2623 15.5072 11.536"
          stroke="currentColor"
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_294_167">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PainterIcon = fplIcon(PainterIconLocal, Icon24BrushLarge);
